import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { TrustPaymentDigitalWalletPage } from './trust-payment-digital-wallet.page';
import { TrustPaymentDigitalWalletPageRoutingModule } from './trust-payment-digital-wallet-routing.module';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    TrustPaymentDigitalWalletPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    TranslateModule
  ],
  declarations: [TrustPaymentDigitalWalletPage],
  exports: [TrustPaymentDigitalWalletPage],
})
export class TrustPaymentDigitalWalletPageModule {}
